module.exports = __webpack_public_path__ + "img/sort-alpha-up.e3cb9902.svg";